export default __webpack_public_path__ + "static/media/icon-checklist.7b88cbf848c08a5e1b08b3def3f8827e.png";